import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function selectionValidator(field: CreateSchemaTypes) {
  const validator = z.array(z.string().nullable());

  return field.required ? validator.min(1, 'Dit veld is verplicht') : validator.optional();
}
